import { TFunction } from "i18next";
import validator from "validator";
import { z } from "zod";

export const getResponsibleFormSchema = (t: TFunction) => {
  return z.object({
    name: z.string().min(1, { message: t("entities.entity.responsibles.errors.name-required") }),
    section: z.string().min(1, { message: t("entities.entity.responsibles.errors.section-required") }),
    email: z.any()
      .transform(val => (typeof val === 'string' && val.trim() === "") ? null : val)
      .nullable()
      .refine(val => val === null || (typeof val === 'string' && validator.isEmail(val)), {
        message: t("entities.entity.responsibles.errors.invalid-email"),
      })
      .optional(),
    mobile: z.any()
      .transform(val => (typeof val === 'string' && val.trim() === "") ? null : val)
      .nullable()
      .refine(val => val === null || (typeof val === 'string' && validator.isMobilePhone(val, "any")), {
        message: t("entities.entity.responsibles.errors.invalid-mobile-phone"),
      })
      .optional(),
    phone: z.any()
      .transform(val => (typeof val === 'string' && val.trim() === "") ? null : val)
      .nullable()
      .refine(val => val === null || (typeof val === 'string' && validator.isMobilePhone(val, "any")), {
        message: t("entities.entity.responsibles.errors.invalid-phone"),
      })
      .optional(),
  });
};

export type ResponsibleForm = z.infer<ReturnType<typeof getResponsibleFormSchema>>;
